var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.646484,
    y: 0.707031,
    width: 27.2941,
    height: 27.2941,
    rx: 7,
    fill: "#3A3A3A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.72057 10.2926H19.8657C20.3053 10.2926 20.6617 10.6563 20.6617 11.1049V17.6035C20.6617 18.0522 20.3053 18.4159 19.8657 18.4159H8.72057C8.28091 18.4159 7.9245 18.0522 7.9245 17.6035V11.1049C7.9245 10.6563 8.28091 10.2926 8.72057 10.2926ZM6.33234 11.1049C6.33234 9.75904 7.40159 8.66797 8.72057 8.66797H19.8657C21.1847 8.66797 22.2539 9.75904 22.2539 11.1049V17.6035C22.2539 18.9494 21.1847 20.0405 19.8657 20.0405H8.72057C7.40159 20.0405 6.33234 18.9494 6.33234 17.6035V11.1049ZM12.701 14.3542C12.701 13.3569 13.8442 12.7922 14.6362 13.3983C15.2658 13.8801 15.2658 14.8284 14.6362 15.3101C13.8442 15.9163 12.701 15.3516 12.701 14.3542Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.c9aa0d46d4e24a7f43a4cefdf07d59a1.svg";
export { ForwardRef as ReactComponent };